import React from "react"
export function RightChevron(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <g
        id="prefix__right-chevron"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <path
          d="M13.29 9.48a.75.75 0 01.076.948l-.075.091L6.574 17.5 5.5 16.461 11.717 10 5.5 3.54 6.574 2.5l6.717 6.98z"
          id="prefix__right"
          fill="currentColor"
          fillRule="nonzero"
        />
      </g>
    </svg>
  )
}
